// extracted by mini-css-extract-plugin
export var arbiterBadgeContainer = "_m-0";
export var colorSwatch = "_m-5";
export var compactSwatch = "_m-7";
export var fillWidth = "_m-4";
export var iconButton = "_m-2";
export var iconWrapper = "_m-3";
export var shadow = "_m-6";
export var xs = "_m-1";